import AddressBookForm from "../../views/UserPortal/AddressBook/AddressBookForm";
import AddressBookView from "../../views/UserPortal/AddressBook/AddressBookView";
import Cart from "../../views/UserPortal/Cart/Cart";
import Checkout from "../../views/UserPortal/Checkout/Checkout";
import OrderPlaced from "../../views/UserPortal/Checkout/OrderPlaced";
import Receipt from "../../views/UserPortal/Checkout/Receipt";
import CouponVouchersTabs from "../../views/UserPortal/Coupon&Vouchers/CouponVouchersTabs";
import ContactUs from "../../views/UserPortal/CustomerServices/ContactUs/ContactUs";
import CustomerServices from "../../views/UserPortal/CustomerServices/CustomerServices";
import CustomerServicesSection from "../../views/UserPortal/CustomerServices/CustomerServicesSection";
import FAQs from "../../views/UserPortal/CustomerServices/FAQs/FAQs";
import GiftCardsTabs from "../../views/UserPortal/GiftCards/GiftCardsTabs";
import JobApplicationTabs from "../../views/UserPortal/JobApplications/JobApplicationTabs";
import MaeStyle from "../../views/UserPortal/MaeStyle/MaeStyle";
import MyReviewsTabs from "../../views/UserPortal/My Reviews/MyReviewsTabs";
import OrderTabs from "../../views/UserPortal/Orders/OrderTabs";
import PaymentInfoTabs from "../../views/UserPortal/Payment Info/PaymentInfoTabs";
import Settings from "../../views/UserPortal/Settings/Settings";
import TicketsTab from "../../views/UserPortal/Tickets/TicketsTab";
import UserDashboard from "../../views/UserPortal/UserDashboard";
import UserMyProfile from "../../views/UserPortal/UserMyProfile";
import WishlistTabs from "../../views/UserPortal/Wishlist/WishlistTabs";

const userRoutes = [

  {
    path: "/dashboard",
    element: <UserDashboard />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/user-profile",
    element: <UserMyProfile />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/address-book",
    element: <AddressBookView />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/address-book-form",
    element: <AddressBookForm />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/payment-info",
    element: <PaymentInfoTabs />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/orders",
    element: <OrderTabs />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/coupons-vouchers",
    element: <CouponVouchersTabs />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/myreviews",
    element: <MyReviewsTabs />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/my-activity",
    element: <WishlistTabs />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/maestyle",
    element: <MaeStyle />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/users/tickets",
    element: <TicketsTab />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/users/jobApplication",
    element: <JobApplicationTabs />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: "/users/giftCards",
    element: <GiftCardsTabs />,
    meta: {
      layout: 'vertical',
      // publicRoute: true,
      // restricted: true
    }
  },
  {
    path: '/cart',
    element: <Cart />,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/cart/checkout',
    element: <Checkout />,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/checkout/order-placed',
    element: <OrderPlaced />,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/checkout/order-placed/e-receipt',
    element: <Receipt />,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/customer-services-section',
    element: <CustomerServicesSection />,
    meta: {
      layout: "vertical"
    }
  },
  {
    path: '/customer-services',
    element: <CustomerServices />,
    meta: {
      layout: "blank"
    }
  },
  {
    path: '/contact-us',
    element: <ContactUs />,
    meta: {
      layout: "blank"
    }
  },
  {
    path: '/settings',
    element: <Settings />,
    meta: {
      layout: "vertical"
    }
  },
  {
    path: '/FAQs',
    element: <FAQs />,
    meta: {
      layout: "blank"
    }
  },
]

export default userRoutes;